import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ModuleExtended, ModuleExtendedListResponse, ModuleQueryParams } from '@frontend/module/types';

export class ModuleExtendedClient extends APIClient {
    public static readonly endpoint = '/module-api/ext/v1';
    public static async fetchModuleExtendeds(queryParams?: ApiQueryParams<ModuleQueryParams>): Promise<ModuleExtendedListResponse> {
        return this.apiPaginated<ModuleExtendedListResponse, ModuleQueryParams>(`${this.endpoint}/modules`, queryParams);
    }

    public static async fetchModuleExtended(accountId: string, spotId: string, moduleId: string): Promise<ModuleExtended> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}`);
        return await this.handleResponse<ModuleExtended>(response);
    }
}
